/* eslint-disable @typescript-eslint/no-var-requires */
//import me from 'models/me';
import sync from "ampersand-sync";
import result from "lodash/result";
import config from "../site-config";
import { getStore } from "store";
import { checkAccessControlError } from "helpers/access-control";
import * as Sentry from "@sentry/browser";

const tryParseJson = (data, context) => {
    if (typeof data === "object") {
        return data;
    }

    try {
        return JSON.parse(data);
    } catch (error) {
        Sentry.captureException(error, context);
        return data;
    }
};

// Wrap an optional error callback with a fallback error event.
const wrapError = function (model, options) {
    const me = require("models/me").default;
    const error = options.error;
    options.error = function (resp, type, message) {
        if (!resp.rawRequest) {
            resp.rawRequest = {
                statusCode: resp.statusCode,
                statusText: resp.statusText || "",
            };
        }
        if (error) {
            if (resp.statusCode === 401 && !options.handle401 && model !== me && model !== me.session) {
                me.logout(true);
            } else {
                if (resp.statusCode === 403) {
                    checkAccessControlError({ error: tryParseJson(resp?.body, resp) });
                }
                error(resp, type, message);
            }
        }
    };
};

// Throw an error when a URL is needed, and none is supplied.
const urlError = function () {
    throw new Error('A "url" property or function must be specified');
};

// One file to control the ajax
const ajaxConfig = {
    scope: null,
    ajaxConfig: function () {
        const me = require("models/me").default;
        const { scope } = getStore().getState();
        let moduleHeader = "default";
        if (this.forceModuleName) {
            moduleHeader = this.forceModuleName;
        }
        return {
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
                // @blocked: API with OAUTH support
                // 'Access-Token': this.accessToken,
                module: moduleHeader, // @todo: change this to be dynamic with the router
                "Active-Brand": me.isSignedIn() && scope.brand ? scope.brand._id || "" : "",
            },
            xhrFields: {
                withCredentials: true,
                timeout: 60000, // 60s timeout
            },
        };
    },

    sync: function (action, model, options) {
        const scope = ajaxConfig.scope;
        if (!options.url) {
            options.url =
                (typeof model.url === "function" ? model.url.call(model, scope) : result(model, "url")) || urlError();
        }
        options.url = config.api + options.url;
        if (options.subdomain) {
            options.url = options.url.replace("https://", `https://${options.subdomain}.`);
        }
        wrapError(model, options);
        // eslint-disable-next-line prefer-rest-params
        return sync.apply(this, arguments);
    },
};

export default ajaxConfig;
